import { Injectable } from '@angular/core';
import { UrlConfig } from 'config/urlConfig';
import { NetworkService } from 'services/network.service';
import { Constants } from 'config/constants';

@Injectable()
export class SalesForceService {
    private business = Constants.calculators.business;
    private events = Constants.calculators.events;
    private individual = Constants.calculators.individual;
    private leadSource = {
        [this.business]: 'Online Calc-Business',
        [this.events]: 'Online Calc-Events',
        [this.individual]: 'Online Calc-Individual'
    };

    constructor(private networkService: NetworkService) {
    }

    private getDataToSend(params, calculator) {
        let leadData = {
            leads: {
                firstName: params.name && params.name.substr(0, params.name.indexOf(' ')),
                lastName: params.name && params.name.substr(params.name.indexOf(' ') + 1) || 'N/A',
                companyName: params.company || 'N/A',
                email: params.email,
                industry: params.industry,
                phone: params.phone,
                zip: params.zip,
                state: params.state,
                country: params.country
            }
        };

        if (calculator === this.business) {
            leadData.leads['jobTitle'] = params.title;
            leadData.leads['numberOfEmployees'] = params.employers;
        } else if (calculator === this.events) {
            leadData.leads['nameOfEvent'] = params.event;
        } else if (calculator === this.individual) {
            leadData.leads['partner_channel'] = params.partner_channel;
            leadData.leads['totalEmission'] = params.co2e_total;
        }

        leadData.leads['leadSource'] = this.leadSource[calculator];

        return leadData;
    }

    public send(params, calculator): any {
        let dataToSend = this.getDataToSend(params, calculator);
        return this.networkService.post(UrlConfig.getUrl('leads'), dataToSend);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/salesforce.service.ts